module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch6"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage3"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch6.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-6"
    }
  }, [_vm._v("Debbie is standing by herself in the corner. You figure Nick and Connor must still be in the kitchen. You approach cautiously.")])]), _c('a', {
    attrs: {
      "id": "pg-6"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you really think this scavenger hunt is for real?” she asks, glancing toward the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah,” you say. “You guys "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("promised")]), _vm._v(" that you’ll let me go if I find the items by midnight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Debbie starts laughing — a hideous cackling laugh. “Fool!” she cries. “It’s a joke! You’re never going to make it out!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You don’t know whether to believe her or not.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you mean?” you ask.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Debbie slithers closer. “I’m on your side,” she whispers. “I used to be a regular kid like you. Then I joined the Horror Club. Now look what’s happened to me!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You stare in amazement at Debbie’s hideous monster face. Is she for real? Was she really once a kid like you?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I want to help you,” she says. “If you follow me, I’ll help you escape.”")])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-6"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If you think Debbie is telling the truth, follow her on ")])]), _c('span', {
    attrs: {
      "href": "#/e9780545841030_ch086",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 86")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If you think it’s best to continue the hunt, turn to "), _c('span', {
    attrs: {
      "href": "#/e9780545841030_ch016",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 16")])]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d6a4f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841030_ch006.vue
// module id = 81
// module chunks = 0